import apiClient from './axiosClient';




export const dashboardApi = {

    getDashboardStats: async (params) => {
        //const res = await apiClient.get(`/api/provider/user/dashboard/getDashboardStats?taxId=${params.taxId?.join(",")}`);
        const res = await apiClient.get(`/api/provider/user/dashboard/getDashboardStats`);
        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    

    getRecentClaims: async (params) => {
        //const res = await apiClient.get(`/api/provider/user/dashboard/getRecentClaims?taxId=${params.taxId?.join(",") }`);
        const res = await apiClient.get(`/api/provider/user/dashboard/getRecentClaims`);
        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },

    getRecentAuthorizations: async (params) => {
        const res = await apiClient.get(`/api/provider/user/dashboard/getRecentAuthorizations?taxId=${params.taxId?.join(",") }`);
        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getClaimStatusCount: async (params) => {
        //const res = await apiClient.get(`/api/provider/user/dashboard/getClaimStatusCounts?taxId=${params.taxId?.join(",") }`);
        const res = await apiClient.get(`/api/provider/user/dashboard/getClaimStatusCounts`);
        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    

        

  //getPendingAuthorizations: () =>
    //  apiClient.get('/dashboard/pending-authorizations'),

    //getPendingAuthorizations: (user) =>
    //    apiClient.get('/api/referral/advanced', {
    //        params: {
    //            referringProvider: user.taxId?.trim(),
    //            referredToProvider: '741706734',
    //            requestFrom: '2018-01-01',
    //            requestTo: '2026-04-13',
    //            pageNo: 1,
    //            pageLimit: 5
    //        }
    //    }),

    //getPendingAuthorizations: async (user) => {
    //    const res = await apiClient.get('/api/referral/advanced', {
    //        params: {
    //            referringProvider: user.taxId?.trim(),
    //            referredToProvider: '741706734',
    //            requestFrom: '2024-01-01',
    //            requestTo: '2026-04-13',
    //            pageNo: 1,
    //            pageLimit: 5
    //        }
    //    });

        
    //    const data = res?.data;
    //    return {
    //        success: data?.Success,
    //        message: data?.Message,
    //        referrals: data?.Data?.Referrals || []   //  all properties preserved
    //    };
    //},
    //getPendingAuthorizations: async (user) => {
    //    const res = await apiClient.get('/api/referral/advanced', {
    //        params: {
    //            referringProvider: user.taxId?.trim(),
    //            referredToProvider: '741706734',
    //            requestFrom: '2024-01-01',
    //            requestTo: '2026-04-13',
    //            pageNo: 1,
    //            pageLimit: 5
    //        }
    //    });


    //    const data = res?.data;
    //    return {
    //        success: data?.Success,
    //        message: data?.Message,
    //        referrals: data?.Data?.Referrals || []   //  all properties preserved
    //    };
    //},
    //GetClaimStatusCount

  getNotifications: (limit = 5) =>
    apiClient.get('/dashboard/notifications', { params: { limit } }),
};
